<template>
  <div :class="['content', programStyle]">
    <div class="upper">
      <div class="title">{{ $t('archive') }}</div>
      <Multiselect
        v-model="value"
        :options="options"
        class="multiselect single"
        :placeholder="$t('select-option')"
        track-by="label"
        label="label"
        :showLabels="false"
      ></Multiselect>
    </div>
    <DataTable :headings="archiveTH" :rows="rows" :perPage="rowCount" :page="currentPage">
      <template v-slot:actionSlot="slotProps">
        <a v-if="slotProps.row.archiveUrl" class="button" :href="slotProps.row.archiveUrl" target="_blank">PDF</a>
      </template>
    </DataTable>
  </div>
</template>

<script>
import DataTable from '@/components/DataTable.vue';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { mapState } from 'vuex';
import archiveTH from '@/utils/tableHeaders/archiveTH';

export default {
  name: 'Archive',
  components: { Multiselect, DataTable },
  data() {
    return {
      archiveResults: [],
      value: null,
      filterValue: null,
      rowCount: 999,
      currentPage: 1,
      options: [
        { label: this.$t('survey-interference-letters'), value: 'si_pdfs' },
        { label: this.$t('coaching-pdfs'), value: 'coaching_pdfs' },
        { label: this.$t('validation-pdfs'), value: 'validation_pdfs' },
      ],
      archiveTH: archiveTH(),
    };
  },
  methods: {
    getArchiveResults() {
      const { domain, entity } = this;
      const loader = this.$loading.show();
      this.value = this.options[0];

      this.$store
        .dispatch('getArchive', { domain, entity })
        .then((res) => {
          this.archiveResults = res;
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
  },
  computed: {
    ...mapState('global', ['programStyle', 'programName']),
    entity() {
      return this.$route.params.entity;
    },
    domain() {
      return this.$route.params.domain;
    },
    rows() {
      if (this.archiveResults && this.value) {
        return this.archiveResults[this.value.value];
      }
      return null;
    },
  },
  watch: {
    programName() {
      this.getArchiveResults();
    },
  },
  created() {
    this.getArchiveResults();
  },
};
</script>

<style lang="scss" scoped>
.content {
  color: #000000;
  text-align: left;
  .link {
    color: #243882;
  }
}
.upper {
  padding: 40px;
}
.title {
  margin-bottom: 24px;
  color: #243882;
  font-size: 21px;
  text-transform: uppercase;
}
</style>
